import { withInstall } from '@/utils'
import MoreButton from './src/moreButton.vue'
export default withInstall(MoreButton)
